import type { FC } from 'react';
import { Outlet } from 'react-router';

const Resources: FC = () => <Outlet />;

export default Resources;
